export default __webpack_public_path__ + "static/media/loading.54979256.svg";